import Coupon from 'types/Coupon';
import Plan from 'types/Plan';
import PlusLandingPageBase from 'components/PlusLandingPageBase';
import { UserId } from '@alltrails/shared/types/User';

type PodcastLandingPageProps = {
  coupon?: Coupon;
  planTypes: Plan[];
  userId?: UserId;
};

export default function PodcastLandingPage({ planTypes, coupon, userId }: PodcastLandingPageProps) {
  const plan = planTypes[0];

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img src="https://listen.audiohook.com/c4a9b58d-9880-4d5a-b9f2-cf6e42071a37/pixel.png?type=pageview" style={{ display: 'none' }} />
      <PlusLandingPageBase
        buttonText="Get AllTrails+ today"
        coupon={coupon}
        headline="Exclusive for podcast listeners"
        title="Get 3 free months of AllTrails+"
        subhead={
          <p>
            Find hikes near you with AllTrails, your companion that leads the way outside. Try AllTrails+ for extra tools like offline maps and more.
          </p>
        }
        userId={userId}
        plan={plan}
      />
    </>
  );
}
